var components = {
  uCheckbox: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-checkbox/u-checkbox" */ "uview-ui/components/u-checkbox/u-checkbox.vue"
    )
  },
  uCellGroup: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-cell-group/u-cell-group" */ "uview-ui/components/u-cell-group/u-cell-group.vue"
    )
  },
  uCellItem: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-cell-item/u-cell-item" */ "uview-ui/components/u-cell-item/u-cell-item.vue"
    )
  },
  uTag: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-tag/u-tag" */ "uview-ui/components/u-tag/u-tag.vue"
    )
  },
  uNumberBox: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-number-box/u-number-box" */ "uview-ui/components/u-number-box/u-number-box.vue"
    )
  },
  uButton: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }